import { render, staticRenderFns } from "./HomeProductStatus.vue?vue&type=template&id=f8a7bffe&scoped=true&"
import script from "./HomeProductStatus.vue?vue&type=script&lang=js&"
export * from "./HomeProductStatus.vue?vue&type=script&lang=js&"
import style0 from "./HomeProductStatus.vue?vue&type=style&index=0&id=f8a7bffe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8a7bffe",
  null
  
)

export default component.exports